import { WSList } from "@wingspanhq/fe-component-library";
import { useCallback, useState } from "react";
import { Route, Switch, useHistory, useLocation } from "react-router-dom";
import { EmbeddedLayout } from "../components/EmbeddedLayout";
import { AlertPendingAccountMicroDeposit } from "../../Settings/components/AlertPendingAccountMicroDeposit";
import { FlowAddFundingMethod } from "../../Settings/components/funding/FlowAddFundingMethod";
import { ManageFundingMethod } from "../../Settings/components/funding/ManageFundingMethod";
import {
  PATH_EMBEDDED_MANAGE_FUNDING_METHOD,
  PATH_EMBEDDED_MANAGE_FUNDING_METHOD_ADD
} from "../paths";
import { parseAllowedFundingMethods } from "../utils/parseAllowedFundingMethods";
import { sendMessageToParent } from "../utils/postMessage";

export const RouteManageFundingMethod: React.FC = () => {
  const history = useHistory();
  const location = useLocation();

  const [availableMethods] = useState(() => {
    const params = new URLSearchParams(location.search);
    const allowedMethods = parseAllowedFundingMethods(
      params.get("allowedMethods") || ""
    );
    // Empty array means "no restriction" — pass undefined so
    // FlowAddFundingMethod shows every available method.
    return allowedMethods.length > 0 ? allowedMethods : undefined;
  });

  const goBackToManage = useCallback(() => {
    history.push(PATH_EMBEDDED_MANAGE_FUNDING_METHOD);
  }, [history]);

  return (
    <EmbeddedLayout>
      <Switch>
        <Route path={PATH_EMBEDDED_MANAGE_FUNDING_METHOD_ADD}>
          <FlowAddFundingMethod
            basePath={PATH_EMBEDDED_MANAGE_FUNDING_METHOD_ADD}
            availableMethods={availableMethods}
            onBack={goBackToManage}
            onNext={goBackToManage}
          />
        </Route>

        <Route path={PATH_EMBEDDED_MANAGE_FUNDING_METHOD}>
          <WSList gap="2XL">
            <AlertPendingAccountMicroDeposit />

            <ManageFundingMethod
              onNext={() => sendMessageToParent("complete", { changed: true })}
              onAddNew={() => {
                history.push(PATH_EMBEDDED_MANAGE_FUNDING_METHOD_ADD);
              }}
            />
          </WSList>
        </Route>
      </Switch>
    </EmbeddedLayout>
  );
};
